export default "__VITE_ASSET__36hitZiq__"